export function composeWhereClause(conditions, useSettingType = true, useChildAge = true) {
  let whereClause = '';

  if (useSettingType) {
    if (conditions && conditions.settingType) {
      if (conditions.settingType === 'All') {
        whereClause += ' AND (setting_type=HOM OR setting_type=CEN)';
      } else if (conditions.settingType === 'Center-based child care') {
        whereClause += ' AND setting_type=CEN';
      } else {
        whereClause += ' AND setting_type=HOM';
      }
    } else {
      // default
      whereClause += ' AND (setting_type=HOM OR setting_type=CEN)';
    }
  }

  if (useChildAge) {
    if (conditions && conditions.childAge) {
      if (conditions.childAge !== 'All') {
        if (conditions.childAge === 'Infants and Toddlers') {
          whereClause += ' AND (age_group=INF OR age_group=TOD)';
        } else {
          whereClause += ' AND age_group=PRE';
        }
      } else {
        whereClause += ' AND (age_group=INF OR age_group=TOD OR age_group=PRE OR age_group=UNC)';
      }
    } else {
      // default
      whereClause += ' AND (age_group=INF OR age_group=TOD OR age_group=PRE OR age_group=UNC)';
    }
  }

  return whereClause;
}

function random(max) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function displayChildAge(childAge, plural = false) {
  if (childAge === 'UNC') return 'Not reported by age';
  if (plural) {
    if (childAge === 'All') return 'Infants, Toddlers, or Preschoolers';
    if (childAge === 'INF,TOD') return 'Infants and Toddlers';
    if (childAge === 'Infants and Toddlers') return 'Infants and Toddlers';
    return 'Preschoolers';
  }
  if (childAge === 'All') return 'child';
  if (childAge === 'INF,TOD') return 'Infant or Toddler';
  if (childAge === 'Infants and Toddlers') return 'Infant or Toddler';
  return 'preschooler';
}

export function displayFacilityType(settingType) {
  if (!settingType || settingType === 'All') return 'Child care';
  if (settingType.toUpperCase() === 'HOM') {
    return 'Family child care (FCC)';
  }

  if (settingType.toUpperCase() === 'CEN') {
    return 'Center-based child care';
  }
  return settingType;
}

export function displayFamilyType(familyType) {
  if (!familyType) {
    return 'family';
  }

  if (familyType === 'All') return 'family';
  return familyType.toLowerCase();
}

export default random;
